<div class="modal-header">
  <h3 class="modal-title">Fehler</h3>
</div>

<div class="modal-body">
  <i class="fa fa-exclamation-triangle fa-2x red-font" aria-hidden="true"></i>
  Die Gewichtsangaben für die Erstellung von Versandetiketten sind ungültig.
</div>

<div class="modal-footer">
  <button class="btn btn-danger" (click)="close()">Ok</button>
</div>
